/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Fable_Plan_CtaInputs */

const en_model_fable_plan_cta = /** @type {(inputs: Model_Fable_Plan_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Fable`)
};

const id_model_fable_plan_cta = /** @type {(inputs: Model_Fable_Plan_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ambil Fable`)
};

/**
* | output |
* | --- |
* | "Get Fable" |
*
* @param {Model_Fable_Plan_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_fable_plan_cta = /** @type {((inputs?: Model_Fable_Plan_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Fable_Plan_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_fable_plan_cta(inputs)
	return en_model_fable_plan_cta(inputs)
});